// Instância do sidebar order pro portal do aluno (student-new).
// O módulo genérico vive em @app/ui/lib/sidebar-order — esse arquivo apenas
// configura DEFAULT_ORDER + INSERT_ANCHOR específicos do aluno e re-exporta.
// Quando outros portais entrarem (teacher/company/manager), cada um cria sua
// própria instância com seu vocabulário de chaves.

import { createSidebarOrder } from "@app/ui/lib/sidebar-order";

export type SidebarKey =
  | "home"
  | "aistudy"
  | "quickstudy"
  | "conexoes"
  | "indicar"
  | "peerchat"
  | "bancos"
  | "descobrir"
  | "anotacoes"
  | "gruposestudo"
  | "turmas"
  | "disciplinas"
  | "provas"
  | "agenda"
  | "mensagens"
  | "notificacoes"
  | "jogos"
  | "ia"
  | "gravador"
  | "compartilhamentos"
  | "assinatura"
  | "formapagamento"
  | "meusreports"
  | "faq"
  | "minhaconta";

const DEFAULT_ORDER: SidebarKey[] = [
  "home",
  "aistudy",
  "quickstudy",
  "conexoes",
  "indicar",
  "peerchat",
  "bancos",
  "descobrir",
  "anotacoes",
  "gruposestudo",
  "gravador",
  "compartilhamentos",
  "turmas",
  "disciplinas",
  "provas",
  "agenda",
  "mensagens",
  "notificacoes",
  "jogos",
  "ia",
  "assinatura",
  "formapagamento",
  "meusreports",
  "faq",
  "minhaconta"
];

const handle = createSidebarOrder<SidebarKey>({
  portalKey: "student",
  defaultOrder: DEFAULT_ORDER,
  /** Quando uma nova chave for adicionada aqui no DEFAULT_ORDER, registrar
   *  o anchor pra encaixar bem em sidebars que JÁ foram customizadas pelo
   *  usuário. Sem registro, cai como "end". */
  insertAnchors: {
    home: "start",
    aistudy: "after:home",
    quickstudy: "after:aistudy",
    conexoes: "after:quickstudy",
    indicar: "after:conexoes",
    peerchat: "after:indicar",
    bancos: "after:peerchat",
    descobrir: "after:bancos",
    anotacoes: "after:descobrir",
    gruposestudo: "after:anotacoes",
    gravador: "after:gruposestudo",
    compartilhamentos: "after:gravador",
    turmas: "after:compartilhamentos",
    disciplinas: "after:turmas",
    provas: "after:disciplinas",
    agenda: "after:provas",
    mensagens: "after:agenda",
    notificacoes: "after:mensagens",
    jogos: "after:notificacoes",
    ia: "after:jogos",
    assinatura: "before:formapagamento",
    formapagamento: "before:meusreports",
    meusreports: "before:faq",
    faq: "before:minhaconta",
    minhaconta: "end"
  }
});

export const sidebarOrder = handle.signal;
export const applyServerSidebarOrder = handle.applyServer;
export const applyPlatformDefaultSidebarOrder = handle.applyPlatformDefault;
export const enableSidebarOrderServerSync = handle.enableServerSync;
export const setSidebarOrder = handle.set;
export const resetSidebarOrder = handle.reset;
export const applyOrderToItems = handle.applyToItems;

/** Busca ordem default vinda do admin (platform-wide) e aplica como fallback. */
export async function loadPlatformSidebarDefault(): Promise<void> {
  try {
    const res = await fetch("/api/sidebar-defaults", {
      credentials: "include"
    });
    if (!res.ok) return;
    const data = (await res.json()) as { defaults?: unknown };
    handle.applyPlatformDefault(data.defaults);
  } catch {
    /* best-effort */
  }
}
